import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { NotificationsResponse } from 'types';
import { refetchUserOnError } from 'utils/refetchUserOnError';

const getNotifications = async (
  unreadOnly?: boolean,
  type?: string,
  limit?: number
): Promise<NotificationsResponse> => {
  const params: {
    unreadOnly?: string;
    type?: string;
    limit?: string;
  } = {};
  if (unreadOnly) {
    params.unreadOnly = 'true';
  }
  if (type) {
    params.type = type;
  }
  if (limit) {
    params.limit = limit.toString();
  }
  const { data } = await customAxios.get<NotificationsResponse>('/notifications', {
    params,
  });
  return data;
};

export const useGetNotifications = (
  unreadOnly?: boolean,
  type?: string,
  limit?: number
): UseQueryResult<NotificationsResponse> => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['notifications', unreadOnly, type, limit],
    queryFn: () => getNotifications(unreadOnly, type, limit),
    refetchInterval: 30000, // Refetch every 30 seconds
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
